(() => {
  'use strict';
  const configNode = document.getElementById('OttVpsConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent || '{}'); } catch (_) { return; }
  if (!config?.popularity?.enabled || !config.popularity.baseUrl) return;
  const origin = config.popularity.baseUrl.replace(/\/$/, '');
  const lang = (document.documentElement.lang || '').toLowerCase().startsWith('en') ? 'en' : 'fr';
  const format = new Intl.NumberFormat(lang === 'en' ? 'en-US' : 'fr-FR', { maximumFractionDigits: 0 });
  let timer = 0;
  let inFlight = false;
  let lastAttempt = 0;
  let failures = 0;
  const cacheKey = 'ottrecord-views-last-known-v199';
  const readCache = () => {
    try {
      const item = JSON.parse(sessionStorage.getItem(cacheKey) || '{}');
      return item.expires > Date.now() && item.values && typeof item.values === 'object' ? item.values : {};
    } catch (_) { return {}; }
  };
  const saveCache = (values) => {
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({expires: Date.now() + 60 * 60 * 1000, values:{...readCache(), ...values}}));
    } catch (_) {}
  };
  const pending = () => [...document.querySelectorAll('[data-ott-entity-type="beat"][data-ott-entity-id]')]
    .filter((root) => root.querySelector('[data-ott-popularity][data-ott-popularity-state="pending"], [data-ott-popularity][data-ott-popularity-state="cached"]'));
  const apply = (values, state) => {
    for (const root of pending()) {
      const key = `beat:${root.dataset.ottEntityId}`;
      const value = values[key];
      if (!Number.isSafeInteger(value) || value < 0) continue;
      const bar = root.querySelector('[data-ott-popularity]');
      const number = bar?.querySelector('[data-ott-popularity-count="views"]');
      if (!number) continue;
      number.textContent = format.format(value);
      bar.dataset.ottPopularityState = state;
      bar.dataset.ottPopularityRecovered = 'true';
      bar.title = state === 'cached' ? (lang === 'en' ? 'Last known views' : 'Dernières vues connues') : '';
    }
  };
  const fetchPending = async () => {
    timer = 0;
    if (inFlight) return;
    const roots = pending();
    if (!roots.length) return;
    const keys = [...new Set(roots.map((root) => `beat:${root.dataset.ottEntityId}`))]
      .filter((key) => /^beat:[0-9]+$/.test(key)).slice(0, 60);
    if (!keys.length) return;
    apply(readCache(), 'cached');
    const now = Date.now();
    if (now - lastAttempt < 3500) return;
    lastAttempt = now;
    inFlight = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 6500);
    try {
      const url = new URL(`${origin}/counts`);
      url.searchParams.set('entities', keys.join(','));
      url.searchParams.set('source', 'shopify-v1');
      const response = await fetch(url, { credentials: 'omit', headers: {Accept:'application/json'}, signal: controller.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const payload = await response.json();
      const entities = payload?.entities || payload?.data || {};
      const values = {};
      for (const key of keys) {
        const raw = entities[key];
        if (!raw || raw.views === '' || raw.views === null || raw.views === undefined) continue;
        const value = Number(raw.views);
        if (Number.isSafeInteger(value) && value >= 0) values[key] = value;
      }
      if (Object.keys(values).length) {
        apply(values, 'recovered');
        saveCache(values);
        failures = 0;
      }
    } catch (_) {
      failures += 1;
      if (failures <= 1) schedule(6000);
    } finally {
      clearTimeout(timeout);
      inFlight = false;
    }
  };
  const schedule = (delay = 5300) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(fetchPending, delay);
  };
  const boot = () => {
    apply(readCache(), 'cached');
    if (pending().length) schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
  document.addEventListener('ott:catalogue:updated', boot);
  window.addEventListener('online', () => {failures = 0; schedule(600);}, {passive:true});
})();
